export class AbstractSerializer {
  [key: string]: any; /* eslint-disable-line */

  serialize(obj: any /* eslint-disable-line */) {
    obj &&
      Object.keys(obj).forEach((o) => (this[o.toString()] = obj[o.toString()]));
    return this;
  }
}
